var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasRequired)?_c('router-link',{attrs:{"to":_vm.to,"target":"_blank"}},[_vm._t("default",function(){return [_vm._v("View notes")]})],2):_c('span',[_vm._t("default",function(){return [_vm._v("View notes")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }